// client/src/components/AdminLayout/index.jsx
import { NavLink, Outlet, redirect, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import './AdminLayout.css';

export default function AdminLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      // קריאה ל-API להתנתקות
      await fetch('/api/users/logout', { method: 'POST', credentials: 'include' });
      redirect('/');
    } catch (e) {
      console.error('Logout error:', e);
    }
    navigate('/admin/login');
  };

  const menuItems = [
    { path: '/admin', icon: '📊', label: 'דשבורד', exact: true },
    { path: '/admin/courses', icon: '📚', label: 'לומדות' },
    { path: '/admin/exams', icon: '📝', label: 'מבחנים' },
    { path: '/admin/users', icon: '👥', label: 'משתמשים' },
    { path: '/admin/surveys', icon: '📋', label: 'סקרי אקלים' },
    { path: '/admin/regulations', icon: '📜', label: 'תקנונים' },
    { path: '/admin/procedures', icon: '📑', label: 'נהלי עבודה' },
    { path: '/admin/reports', icon: '📈', label: 'דוחות' },
    { path: '/admin/settings', icon: '⚙️', label: 'הגדרות' },
  ];

  return (
    <div className={`admin-layout ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
      {/* Sidebar */}
      <aside className="admin-sidebar">
        <div className="sidebar-header">
          <div className="logo">
            {!sidebarCollapsed && <span className="logo-text">ניהול LMS</span>}
            <span className="logo-icon">🎓</span>
          </div>
          <button 
            className="collapse-btn"
            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
            title={sidebarCollapsed ? 'הרחב תפריט' : 'צמצם תפריט'}
          >
            {sidebarCollapsed ? '◀' : '▶'}
          </button>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.exact}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
              title={sidebarCollapsed ? item.label : ''}
            >
              <span className="nav-icon">{item.icon}</span>
              {!sidebarCollapsed && <span className="nav-label">{item.label}</span>}
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <button 
            className="nav-item logout-btn"
            onClick={handleLogout}
            title={sidebarCollapsed ? 'התנתק' : ''}
          >
            <span className="nav-icon">🚪</span>
            {!sidebarCollapsed && <span className="nav-label">התנתק</span>}
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}